import { render } from "./BotMatchGround.vue?vue&type=template&id=180d8dba&scoped=true"
import script from "./BotMatchGround.vue?vue&type=script&lang=js"
export * from "./BotMatchGround.vue?vue&type=script&lang=js"

import "./BotMatchGround.vue?vue&type=style&index=0&id=180d8dba&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-180d8dba"]])

export default __exports__